"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = disableAllCookies;
var _cookies_config = _interopRequireDefault(require("Components/Cookies/cookies_config"));
var _CookiesStore = _interopRequireDefault(require("Components/Stores/CookiesStore"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function disableAllCookies() {
  const codes = Object.keys(_cookies_config.default);
  _CookiesStore.default.update(function (store) {
    codes.forEach(code => {
      store['enabled_' + code] = false;
    });
  });
}
